export default "__VITE_ASSET__e74b8316__"